import { makeStyles } from "@material-ui/core";
import styled from "styled-components";

import { theme } from "../../themes/themes";
export const GeneralContainer = styled.div`
  width: 100%;
  .MuiTableCell-root {
    padding: 12px;
  }
  .MuiTableCell-alignLeft {
    text-align: center;
  }
`;

export const useStyles = makeStyles(() => ({
  delete: {
    color: theme.status.error,
  },
}));
